export default {
  bill: 'Impossible de télécharger la facture, veuillez rééssayer plus tard.'
}
